import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useOrganizationConfig } from '../hooks/useOrganizationConfig';
import LoadingFallback from '../components/elements/LoadingFallback';

const DynamicBistroRoute = ({ children }) => {
  const { config, loading } = useOrganizationConfig();
  const params = useParams();

  if (loading) {
    return <LoadingFallback />;
  }

  // Check if current path matches the configured slug
  const currentPath = window.location.pathname;
  const expectedSlug = config?.slug || 'bistro';
  
  // If path doesn't start with expected slug, redirect
  if (!currentPath.startsWith(`/${expectedSlug}/`)) {
    const newPath = currentPath.replace(/^\/[^\/]+/, `/${expectedSlug}`);
    return <Navigate to={newPath} replace />;
  }

  return children;
};

export default DynamicBistroRoute;